import {collection, getCountFromServer, query,} from 'firebase/firestore'
import {fire} from "../../../fire";

export const contarWheres = ({coleccion, wheres}) => {
    // 0 es enero


    let col = collection(fire, coleccion)
    const q = query(col, ...wheres);


    return new Promise(resolve => {
        getCountFromServer(q).then((dox) => {
            return resolve({res: true, data: dox.data().count})
        }).catch((err) => {
            console.log(err)
            return resolve({res: false, data: 0})
        })
    })


}